import React, {
    Component
} from 'react';
import {
    domainUrl
} from '../config/Config';
import {
    message,
    getTokenData,
    reactLoader
} from '../helpers/Common';
const $ = window.$;
export default class VoiceRecorder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recordButton: true,
            statusMsg: ""
        };
    }
    audioRecord() {
        window.Fr.voice.record(false, function() {
            this.setState({
                recordButton: false,
                stopButton: true,
                recordProgress: true,
                playButton: false,
                completeButton: false
            })
        }.bind(this));
    }
    audioStop() {
        window.Fr.voice.pause();
        this.setState({
            stopButton: false,
            recordButton: true,
            playButton: true,
            completeButton: true,
            recordProgress: false
        })
    }
    audioPlay() {
        let uniqueID = this.props.questionData.question_id,
            audioTag = $("#audio" + uniqueID);
        window.Fr.voice.export(function(url) {
            audioTag.attr("src", url);
            audioTag[0].play();
        }, "URL");
    }
    audioComplete() {
        let uniqueID = this.props.questionData.question_id,
            audioTag = $("#audio" + uniqueID),
            hiddenTag = $('input[name="' + uniqueID + '"]');
        window.Fr.voice.export(function(base64) {
            reactLoader("show", "Please wait...");
            fetch(domainUrl + "upload/recorded-voice", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    "audio": base64
                })
            }).then((response) => response.json()).then((responseJson) => {
                reactLoader("hide");
                if (responseJson.status === 0) {
                    message(responseJson.message, responseJson.errors, "error");
                } else {
                    window.Fr.voice.stop();
                    audioTag.attr("src", responseJson.path);
                    hiddenTag.val(responseJson.name);
                    this.setState({
                        recordButton: false,
                        playButton: false,
                        completeButton: false,
                        statusMsg: responseJson.message
                    })
                }
            });
        }.bind(this), "base64");
    }
    render() {
        const {
            questionData
        } = this.props;
        return (<div data-type="mp3" className="voice-record">
            {
                this.state.recordProgress &&
                <p style={{textAlign: "center"}}><img src={process.env.PUBLIC_URL +"/images/recording-icon.gif"} width="50" height="50" alt="" />Recording...</p>
            }
            <ul className="btn-ul">
                <li>
                    {
                        this.state.recordButton &&
                        <a className="button recordButton" style={{borderRadius: "25px", padding:"10px 40px", marginLeft:"50px"}} onClick={()=>this.audioRecord()}>
                            <i className="fa fa-microphone"></i>Record
                        </a>
                    }
                </li>
                <li>
                    {
                          this.state.stopButton &&
                        <a className="button ply-btn" style={{borderRadius: "25px", padding: "10px 40px"}} onClick={()=>this.audioStop()}>
                            <i className="fa fa-stop"></i>Stop
                        </a>
                    }
                    {
                        this.state.playButton &&
                        <a className="button ply-btn" style={{borderRadius: "25px", padding: "10px 40px"}} onClick={()=>this.audioPlay()}>
                            <i className="fa fa-play"></i>Play
                        </a>
                    }
                    {
                        this.state.completeButton &&
                        <a className="button complete-btn" style={{borderRadius: "25px", padding: "10px 40px", marginLeft: "20px"}} onClick={()=>this.audioComplete()}>Submit</a>
                    }
                </li>
                <li className="widht-100">
                    <audio className="audio-btm" id={`audio${questionData.question_id}`} controlsList="nodownload" controls></audio>
                    <div style={{color: "green"}}>{this.state.statusMsg}</div>
                    <input type="hidden" name={questionData.question_id} className="required" />
                </li>
            </ul>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/VoiceRecorder.js